import { render } from "./DetailedVoteView.vue?vue&type=template&id=1080acc5&scoped=true"
import script from "./DetailedVoteView.vue?vue&type=script&lang=js"
export * from "./DetailedVoteView.vue?vue&type=script&lang=js"

import "./DetailedVoteView.vue?vue&type=style&index=0&id=1080acc5&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1080acc5"]])

export default __exports__